import { Route, Switch } from 'react-router-dom';
import { useState } from 'react';
import './css/style.css';
import './css/tailwind.css';

import Header from "./components/Header";
import Footer from "./components/Footer";
import Main from './components/Main';
import Projects from './components/Projects';
import Experiences from './components/Experiences';
import Interests from './components/Interests';
import Youtube from './components/Youtube';
import Mymap from './components/Mymap';
import Cv from './components/Cv';
import Contact from './components/Contact';
import Privacy from './components/Privacy';

function App() {
  const [commuFirstContsIsActive, setCommuFirstContsIsActive] = useState(null);

  return (
    <div className="App">
      <Header />
      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/portfolio" component={Main} />
        <Route exact path="/projects" render={() => <Projects setCommuFirstContsIsActive={setCommuFirstContsIsActive} commuFirstContsIsActive={commuFirstContsIsActive} />} />
        <Route exact path="/experiences" component={Experiences} />
        <Route exact path="/interests" component={Interests} />
        <Route exact path="/youtube" component={Youtube} />
        <Route exact path="/mymap" component={Mymap} />
        <Route exact path="/cv" component={Cv} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/privacy" component={Privacy} /> 
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
